import ApplicationController from '../application_controller'
import Fetchers from "core/fetchers";

export default class CartController extends ApplicationController {
  static targets = ["cartContent", "cartItem", "cartQuantity", "paypalBtn", "cartUpdateSuccessMessage", "successMessageQuantity"];
  static values = {
    quantity: { type: Number, default: 0 },
    fireRequest: { type: Boolean, default: true },
    lazyloadPath: String,
  }

  paypalBtnTargetConnected(element) {
    TeePublic.Cart.CheckoutPaypal?.init("responsive", `#${element.id}`);
  }

  fetch(path) {
    return Fetchers.fetchJSON(path)
      .then(Fetchers.parseResponse)
      .then((res) => {
        if (window.location.pathname === "/cart") {
          window.location.reload();
        } else {
          this.updateCartTrayContent(res);
          this.quantityValue = this.cartQuantityTarget.dataset.cartQuantityTotal;
          this.updateBadgeNotification();
        }
      });
  }

  updateBadgeNotification() {
    const badges = document.querySelectorAll('.jsNotificationBadge');

    badges.forEach((badge) => {
      const badgeNotification = badge.notification;
      badgeNotification.countValue = this.quantityValue;
      badgeNotification.updateCount();
    })
  }

  updateCartTrayContent(res) {
    const htmlString = res.data.html;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    const trayContent = tempDiv.querySelector('.drawer__wrapper');
    this.cartContentTarget.querySelector('.drawer__wrapper').innerHTML = trayContent.innerHTML;
  }

  lazyloadCartTray() {
    if (!this.fireRequestValue) return;
    Fetchers.fetchGeneric(this.lazyloadPathValue)
      .then(Fetchers.parseResponse)
      .then((res) => {
        this.updateCartTrayContent(res);
        this.quantityValue = this.cartQuantityTarget.dataset.cartQuantityTotal;
        this.updateBadgeNotification();
        this.fireRequestValue = false;
        // manually dispatch event
        const event = new CustomEvent('lazyload')
        window.dispatchEvent(event)
      })
      .catch((error) => this.handleError(error));
  }

  removeItem(e) {
    e.preventDefault();
    let item = e.currentTarget.closest('.jsHeadCartItem')
    let path = e.currentTarget.dataset.path
    item.remove();
    this.fetch(path);
  }
}
